export { default } from './CompanionAd';
